import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { LoaderComponent } from './loader/loader.component';
import { SelectCountryComponent } from './components/modals/select-country/select-country.component';
import { SplashComponent } from './components/splash/splash.component';
import { SwipeComponent } from './components/swipe/swipe.component';
import { ConfirmPaymentComponent } from './components/modals/confirm-payment/confirm-payment.component';
import { TabBarComponent } from './components/tab-bar/tab-bar.component';
import { PickerComponent } from './components/game/picker/picker.component';
import { QuantityComponent } from './components/game/quantity/quantity.component';
import { SelectMethodComponent } from './components/game/select-method/select-method.component';
import { DateListComponent } from './components/game/date-list/date-list.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NumbersComponent } from './components/game/numbers/numbers.component';
import { PickerGatoComponent } from './components/game/picker-gato/picker-gato.component';
import { OptionsComponent } from './components/game/options/options.component';
import { FavoriteComponent } from './components/game/favorite/favorite.component';
import { InstructionsComponent } from './components/game/instructions/instructions.component';
import { SelectTicketComponent } from './components/game/select-ticket/select-ticket.component';
import { SizeSelectorComponent } from './components/game/size-selector/size-selector.component';
import { DateDiferencePipe } from './pipes/date-diference.pipe';
import { TrisCombosComponent } from './components/modals/tris-combos/tris-combos.component';
import { TrisMultiplicadorComponent } from './components/modals/tris-multiplicador/tris-multiplicador.component';
import { QuinielaComponent } from './components/game/quiniela/quiniela.component';
import { CountdownTimerComponent } from './components/game/countdown-timer/countdown-timer.component';
import { RechargePaymentComponent } from './components/modals/recharge-payment/recharge-payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoardsComponent } from './components/boards/boards.component';
import { RecommendationComponent } from './components/game/recommendation/recommendation.component';
import { HeaderHomeComponent } from './components/header-home/header-home.component';
import { WalletBtnComponent } from './components/wallet-btn/wallet-btn.component';
import { WalletCardComponent } from './components/wallet-card/wallet-card.component';
import { WalletTransactionsComponent } from './components/wallet-transactions/wallet-transactions.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';
import { WalletTransactionDetailComponent } from './components/wallet-transaction-detail/wallet-transaction-detail.component';
import { MaintenanceWindowComponent } from './components/maintenance-window/maintenance-window.component';
@NgModule({
  imports: [IonicModule, TranslateModule, CommonModule, ReactiveFormsModule, FormsModule],
  declarations: [
    LoaderComponent,
    SelectCountryComponent,
    SplashComponent,
    SwipeComponent,
    ConfirmPaymentComponent,
    PickerComponent,
    QuantityComponent,
    SelectMethodComponent,
    DateListComponent,
    HeaderComponent,
    HeaderHomeComponent,
    WalletBtnComponent,
    FooterComponent,
    TabBarComponent,
    NumbersComponent,
    PickerGatoComponent,
    OptionsComponent,
    FavoriteComponent,
    InstructionsComponent,
    SelectTicketComponent,
    SizeSelectorComponent,
    DateDiferencePipe,
    TrisCombosComponent,
    TrisMultiplicadorComponent,
    QuinielaComponent,
    CountdownTimerComponent,
    RechargePaymentComponent,
    BoardsComponent,
    RecommendationComponent,
    WalletCardComponent,
    WalletTransactionsComponent,
    SafeHtmlPipe,
    CustomToastComponent,
    WalletTransactionDetailComponent,
    SafeUrlPipe,
    MaintenanceWindowComponent,
  ],
  exports: [
    LoaderComponent,
    SelectCountryComponent,
    SplashComponent,
    SwipeComponent,
    ConfirmPaymentComponent,
    PickerComponent,
    QuantityComponent,
    SelectMethodComponent,
    DateListComponent,
    HeaderComponent,
    HeaderHomeComponent,
    WalletBtnComponent,
    FooterComponent,
    TabBarComponent,
    NumbersComponent,
    PickerGatoComponent,
    OptionsComponent,
    FavoriteComponent,
    InstructionsComponent,
    SelectTicketComponent,
    SizeSelectorComponent,
    DateDiferencePipe,
    TrisCombosComponent,
    TrisMultiplicadorComponent,
    QuinielaComponent,
    CountdownTimerComponent,
    RechargePaymentComponent,
    BoardsComponent,
    RecommendationComponent,
    WalletCardComponent,
    WalletTransactionsComponent,
    FormsModule,
    SafeHtmlPipe,
    CustomToastComponent,
    SafeUrlPipe,
    MaintenanceWindowComponent,
    FormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
